import type { ExtractPropTypes } from 'vue'
import {
  inputProps as elInputProps,
  inputEmits as elInputEmits,
} from 'element-plus'
import { useLocale } from '@el-plus/hooks/use-locale'
const { t } = useLocale()

export const inputProps = {
  ...elInputProps,
  max: Number,
  min: Number,
  radix: Number,
  nonzero: Boolean,
  placeholder: {
    type: String,
    default: () => {
      return t('ep.input.placeholder')
    },
  },
  thousand: {
    type: Boolean,
    default: true,
  },
  clearable: {
    ...elInputProps.clearable,
    default: true,
  },
  clearableFocus: {
    type: Boolean,
    default: true,
  },
} as const
export type InputProps = ExtractPropTypes<typeof inputProps>
export const inputEmits = {
  ...elInputEmits,
  click: (evt: MouseEvent) => evt instanceof MouseEvent,
}
export type InputEmits = typeof inputEmits
export const inputEmitsKeys = Object.keys(inputEmits)

//  max: Number,
//     min: Number,
//     nonzero: Boolean,
//     format: Function,
//     radix: {
//       type: [String, Number],
//       default: 5,
//     },
//     thousand: {
//       type: Boolean,
//       default: false,
//     },
